import styled from 'styled-components'

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* min-height: 100vh; */
`;

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20%;
`;

export const FooterContainer = styled.div`
  background-color: black;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const FooterText = styled.p`
  font-size: 16px;
  color: #ffc706;
`;

export const Button = styled.button`
  background-color: #F0D8C0;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 330px;
  height: 120px;
  margin: auto;
  margin-bottom: 300px;
  font-size: 40px;
  font-weight: bold;
  border-radius: 60px;
`;